
import { css } from '@emotion/core';
import { constants } from '@newsela/angelou';

const uiColors = constants.colors.ui;

export const $divider = css`
  border-bottom: solid 1px ${uiColors.neutral[100]};
`;
